<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{ title | translate }}</span>
            <button mat-icon-button (click)="close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24">
        <div *ngIf="loading" fxLayout="row" fxLayoutAlign="center center" style="min-height: 200px;">
            <mat-spinner [diameter]="40"></mat-spinner>
        </div>

        <div *ngIf="!loading && trainings.length === 0" fxLayout="row" fxLayoutAlign="center center" style="min-height: 200px; color: rgba(0,0,0,0.54);">
            <span>{{'No training sessions found'|translate}}</span>
        </div>

        <div *ngIf="!loading && trainings.length > 0">
            <table class="table table-hover" style="width: 100%;">
                <thead>
                <tr>
                    <th>{{'Date'|translate}}</th>
                    <th>{{'Customer'|translate}}</th>
                    <th>{{'Device'|translate}}</th>
                    <th style="text-align: center;">{{'Distance'|translate}} (km)</th>
                    <th style="text-align: center;">{{'Calories'|translate}}</th>
                    <th>{{'Status'|translate}}</th>
                    <th>{{'Actions'|translate}}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let training of trainings">
                    <td>{{training.createdAt | date: 'd.MM.y H:mm':'UTC': 'pl'}}</td>
                    <td>{{training.user ? (training.user.firstName + ' ' + training.user.lastName) : '-'}}</td>
                    <td>{{training.resource?.name || training.deviceType || '-'}}</td>
                    <td style="text-align: center;">{{training.metrics?.distance ? (training.metrics.distance / 100000 | number:'1.1-2') : '-'}}</td>
                    <td style="text-align: center;">{{training.metrics?.calories ? (training.metrics.calories | number:'1.0-0') : '-'}}</td>
                    <td>
                        <span *ngIf="training.isActive" style="color: green;">{{'Active'|translate}}</span>
                        <span *ngIf="!training.isActive" style="color: gray;">{{'Finished'|translate}}</span>
                    </td>
                    <td>
                        <button mat-icon-button (click)="goToDetails(training)" matTooltip="{{'View Details'|translate}}">
                            <mat-icon>visibility</mat-icon>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>